// /Users/apichet/Downloads/cheetah-insurance-app/src/context/GlobalLoaderContext.js
// /Users/apichet/Downloads/cheetah-insurance-app/src/context/GlobalLoaderContext.js
import React, { createContext, useState, useContext, useMemo, useCallback } from "react";

const LoaderContext = createContext(undefined);

/**
 * Features:
 * - isLoading: boolean
 * - setIsLoading(boolean): backward compatible
 * - show(): เพิ่มตัวนับโหลด +1 (รองรับโหลดซ้อนหลายจุด)
 * - hide(): ลดตัวนับโหลด -1 (ไม่ให้ติดลบ)
 * - withLoader(asyncFn): โชว์โหลดขณะรัน async แล้วซ่อนให้อัตโนมัติ
 */
export const LoaderProvider = ({ children }) => {
  const [count, setCount] = useState(0);

  const isLoading = count > 0;

  const show = useCallback(() => setCount((c) => c + 1), []);
  const hide = useCallback(() => setCount((c) => (c > 0 ? c - 1 : 0)), []);

  // Back-compat: อนุญาต setIsLoading แบบเดิม
  const setIsLoading = useCallback((next) => {
    if (next) setCount((c) => c + 1);
    else setCount(0); // ปิดทุกรายการโหลดทันที (พฤติกรรมเดิม)
  }, []);

  const withLoader = useCallback(async (fn) => {
    show();
    try {
      return await fn();
    } finally {
      hide();
    }
  }, [show, hide]);

  const value = useMemo(
    () => ({ isLoading, setIsLoading, show, hide, withLoader }),
    [isLoading, setIsLoading, show, hide, withLoader]
  );

  return <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>;
};

export const useLoader = () => {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error("useLoader must be used within a LoaderProvider");
  return ctx;
};
